import LoginPage from './LoginPage';
import PropTypes from 'prop-types';
import React from 'react';
import querystring from 'querystring';
import {Center, Flex, Spinner} from '@chakra-ui/react';
import {Elements} from '@stripe/react-stripe-js';
import {GET_USER} from '../utils/queries';
import {UserContext} from '../utils';
import {loadStripe} from '@stripe/stripe-js';
import {navigate} from 'gatsby';
import {useMount} from 'react-use';
import {useQuery} from '@apollo/client';

const stripePromise = loadStripe(process.env.GATSBY_STRIPE_PUBLISHABLE_KEY);

function LoggedIn(props) {
  useMount(() => {
    const {i} = querystring.parse(location.search.slice(1));
    if (i) {
      navigate(location.pathname, {replace: true});
    }
  });
  return (
    <Elements stripe={stripePromise}>
      <Flex maxW="container.xl" minH="100vh" mx="auto" {...props} />
    </Elements>
  );
}

export default function RequireAuth({children}) {
  const {data, loading, client} = useQuery(GET_USER);

  if (loading) {
    return (
      <Center h="100vh">
        <Spinner size="lg" />
      </Center>
    );
  }

  if (data?.me) {
    return (
      <UserContext.Provider
        value={{
          user: data.me,
          client
        }}
      >
        <LoggedIn>{children}</LoggedIn>
      </UserContext.Provider>
    );
  }

  return <LoginPage />;
}

RequireAuth.propTypes = {
  children: PropTypes.node.isRequired
};
